import { render, staticRenderFns } from "./BaseUserNotifications.vue?vue&type=template&id=33c3a986&scoped=true&"
import script from "./BaseUserNotifications.vue?vue&type=script&lang=js&"
export * from "./BaseUserNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BaseUserNotifications.vue?vue&type=style&index=0&id=33c3a986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3a986",
  null
  
)

export default component.exports